import { LoadingProgress } from '@issuemanager/apps/client/components';
import { Box, BoxProps, styled } from '@mui/material';
import { WithTheme } from '@issuemanager/apps/client/theme';

type Props = BoxProps & {
  showLoading?: boolean;
};

const StyledBox = styled(Box)<WithTheme<BoxProps>>`
  ${({ theme, padding }) => `
    background-color: ${theme.tokens.semantic.color.background.container.value};
    padding: ${padding || `${theme.spacing(3)} ${theme.spacing(2)}`};
    border-radius: ${theme.spacing(1)};
  `}
`;

export function ViewSection(props: Props) {
  return (
    <StyledBox {...props}>
      {props.showLoading ? <LoadingProgress /> : props.children}
    </StyledBox>
  );
}
